<div class="card bolt-background-ultralightGray">
    <div class="card-body">
        <ng-content></ng-content>
    </div>
</div>